import Http from '../Http';

export class ChoferService {
  static async obtenerLista(page = 0, limit = 15, filters: Record<string, string> = {}, orderBy = '', order = 'asc') {
    const params = new URLSearchParams();
    params.set('p', page.toString());
    params.set('l', limit.toString());
    
    if (Object.keys(filters).length) {
      params.set('q', JSON.stringify(filters));
    }
    if (orderBy) {
      params.set('orderBy', orderBy);
      params.set('order', order);
    }

    try {
      const res = await Http.get(`chofer/filter?${params.toString()}`);
      return res.data.rows || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  static async eliminar(row: any) {
    try {
      const res = await Http.post(`chofer/delete`, row);
      return !res.error;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  static async obtenerPorId(id: string | number) {
    try {
      const res = await Http.get(`chofer/one/${id}`);
      return res.data;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  static async guardar(data: Record<string, any>) {
    try {
      const res = await Http.post('chofer/save', data);
      return res;
    } catch (e) {
      console.error(e);
      return { error: true, errMsg: (e as any)?.message || 'Error al guardar el chofer' };
    }
  }

  static async obtenerFormGenerales(params: { e?: string | number; cp?: string | number } = {}) {
    const searchParams = new URLSearchParams();
    if (params.e) searchParams.set('e', String(params.e));
    if (params.cp) searchParams.set('cp', String(params.cp));
    try {
      const queryStr = searchParams.toString();
      const url = queryStr ? `cliente/form-generales?${queryStr}` : `cliente/form-generales`;
      const res = await Http.get(url);
      return res.data;
    } catch (e) {
      console.error(e);
      return {};
    }
  }
}
